import { getQuestionNodeFromLabel, inputText } from "@lib/_common/util/surveyUtil";
import { IScanAuditData } from "./types";

const LOCALSTORAGE_API_KEY_NAME = "minted-upc-picker-api-key";

export async function main(allUpcs: string[]) {
  const resp = await getProductsFromScanAudit();
  const auditScanData = (await resp.json()) as IScanAuditData;

  const upcsInStock: Set<string> = new Set();
  auditScanData.products_in_stock.forEach((product) => {
    upcsInStock.add(product.upc);
  });

  const upcsOutOfStock: string[] = [];
  allUpcs.forEach((upc) => {
    if (!upcsInStock.has(upc)) {
      upcsOutOfStock.push(upc);
    }
  });

  const labelText = "Scan Out of Stocks After Stocking OR Key in the UPC";
  const questionNode = getQuestionNodeFromLabel(labelText);
  if (questionNode !== null) {
    questionNode.scrollIntoView();
  }

  upcsOutOfStock.forEach((upc) => {
    inputText(labelText, upc, { clickSubmit: true });
  });

  const oosTableBody = document.querySelector("table[id*='OutOfStock'] > tbody") as HTMLElement;
  const actualOosCount = oosTableBody.childElementCount;

  inputText("How many out of stocks on your POG after servicing?", actualOosCount.toString());

  alert(
    `${upcsOutOfStock.length} OOS / ${allUpcs.length} total items. Actual OOS count (from table body content): ${actualOosCount}`
  );
}

function getProductsFromScanAudit() {
  const apiKey = localStorage.getItem(LOCALSTORAGE_API_KEY_NAME);
  if (apiKey === null) {
    throw new Error(
      `API key could not be retrieved from local storage key: ${LOCALSTORAGE_API_KEY_NAME}`
    );
  }

  const endpointUrl = new URL(
    "https://inventory-manager.mmonj.com/product_locator/api/get_products_from_latest_scan_audit/"
  );

  const headers = {
    Authorization: `Token ${apiKey}`,
  };

  return fetch(endpointUrl, {
    method: "GET",
    headers: headers,
  });
}
